<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الإرسال إلى: <span class="req">*</span></label>
            <select v-model="sendFor" class="form-control">
              <option v-for="(val, key) in sendForObj" :value="key" :key="key">{{ val }}</option>
            </select>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">عنوان الاشعار:</label>
            <input type="text" v-model="title" class="form-control" placeholder="مثلاً : عميلنا العزيز ...">
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الإشعار: <span class="req">*</span></label>
            <textarea v-model="notificationMessage" class="form-control" rows="3"></textarea>
          </div>
        </div>

        <div class="row">
          <div v-if="!isUpdateMode" class="col-12 col-sm-6 mb-3">
            <label class="form-label">إشعار مجدول:</label>
            <div class="form-check form-switch mt-1">
              <input class="form-check-input" type="checkbox" id="isSchedule" v-model="isSchedule">
              <label class="form-check-label" for="isSchedule">{{ isSchedule ? 'نعم' : 'لا' }}</label>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3" v-if="isSchedule">
            <label class="form-label">تاريخ الجدولة: <span class="req">*</span></label>
            <input type="date" class="form-control mb-2" v-model="scheduleDate" :min="todayDate">
            <label class="form-label">وقت الجدولة: <span class="req">*</span></label>
            <select class="form-control" v-model="scheduleTime">
              <option value="">-- اختر الوقت --</option>
              <option v-for="slot in timeSlots" :key="slot.value" :value="slot.value">{{ slot.label }}</option>
            </select>
          </div>
        </div>
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <router-link v-if="isUpdateMode" to="/mNotifications" class="btn btn-secondary me-2">إلغاء</router-link>
            <button v-if="!formLoader" type="submit" :class="isUpdateMode ? 'btn btn-warning' : 'btn btn-success'">
              {{ isUpdateMode ? 'تحديث الإشعار' : 'ارسل' }}
            </button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast, timeSlots, shortDate } from '@/helpers/tools';

export default {
  name: 'MNotificationsForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة',
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      sendForObj: {
        client: 'العميل',
        provider: 'المزود',
      },
      sendFor: 'client',
      title: null,
      notificationMessage: '',
      isSchedule: false,
      scheduleDate: null,
      scheduleTime: '',
      timeSlots: timeSlots(),
    };
  },
  computed: {
    isUpdateMode() {
      return !!(this.dataRow && this.dataRow.id);
    },
    todayDate() {
      return shortDate(new Date());
    },
  },
  methods: {
    async subimtData() {
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if (!this.notificationMessage || this.notificationMessage.trim() == '') {
        this.message = 'يجب ادخال الإشعار';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return;
      }

      if (this.isSchedule && (!this.scheduleDate || !this.scheduleTime)) {
        this.message = 'يجب تحديد تاريخ ووقت الجدولة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return;
      }

      const payload = {
        sendFor: this.sendFor,
        title: this.title,
        message: this.notificationMessage,
        isSchedule: this.isUpdateMode ? true : this.isSchedule,
        scheduleDate: this.isSchedule && this.scheduleDate && this.scheduleTime
          ? `${this.scheduleDate}T${this.scheduleTime}:00`
          : null,
      };

      const confirmTitle = this.isUpdateMode
        ? 'هل تريد تأكيد تحديث الإشعار المجدول ؟'
        : this.isSchedule
          ? 'هل تريد تأكيد جدولة الإشعار ؟'
          : 'هل تريد تأكيد إرسال الإشعار ، لا يمكن التراجع عنه ؟';

      const confirmPrompt = await this.$swal.fire({
        title: confirmTitle,
        showCancelButton: true,
        confirmButtonText: this.isUpdateMode ? 'تحديث' : this.isSchedule ? 'جدولة' : 'إرسال',
        cancelButtonText: 'إلغاء',
        confirmButtonColor: '#f7d630',
      });

      if (confirmPrompt.isConfirmed) {
        const api = this.isUpdateMode
          ? this.$http.put(`/api/admin/mNotifications/update/${this.dataRow.id}`, payload)
          : this.$http.post('/api/admin/mNotifications/create', payload);

        api.then(() => {
          toast(this.isUpdateMode ? 'تم تحديث الإشعار المجدول بنجاح' : this.isSchedule ? 'تم الجدولة بنجاح' : 'تم الإرسال بنجاح', 'success');
          this.$router.replace('/mNotifications').catch(() => {});
          this.formLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
          this.formLoader = false;
        });
      } else {
        this.formLoader = false;
      }
    },
  },
  created() {
    if (this.dataRow) {
      this.sendFor = this.dataRow.sendFor;
      this.title = this.dataRow.title;
      this.notificationMessage = this.dataRow.message;
      this.isSchedule = this.dataRow.isSchedule || false;
      if (this.dataRow.scheduleDate) {
        const d = new Date(this.dataRow.scheduleDate);
        this.scheduleDate = shortDate(d);
        const hh = String(d.getHours()).padStart(2, '0');
        const mm = String(d.getMinutes()).padStart(2, '0');
        this.scheduleTime = `${hh}:${mm}`;
      }
    }
  },
};
</script>